export var Currencies;
(function (Currencies) {
    Currencies["AUD"] = "AUD";
    Currencies["BRL"] = "BRL";
    Currencies["CAD"] = "CAD";
    Currencies["CHF"] = "CHF";
    Currencies["CZK"] = "CZK";
    Currencies["DKK"] = "DKK";
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["HKD"] = "HKD";
    Currencies["HUF"] = "HUF";
    Currencies["ILS"] = "ILS";
    Currencies["JPY"] = "JPY";
    Currencies["MXN"] = "MXN";
    Currencies["MYR"] = "MYR";
    Currencies["NOK"] = "NOK";
    Currencies["NZD"] = "NZD";
    Currencies["PHP"] = "PHP";
    Currencies["PLN"] = "PLN";
    Currencies["RUB"] = "RUB";
    Currencies["SEK"] = "SEK";
    Currencies["SGD"] = "SGD";
    Currencies["THB"] = "THB";
    Currencies["TWD"] = "TWD";
    Currencies["USD"] = "USD";
    Currencies["BIF"] = "BIF";
    Currencies["CVE"] = "CVE";
    Currencies["KMF"] = "KMF";
    Currencies["CDF"] = "CDF";
    Currencies["DJF"] = "DJF";
    Currencies["ERN"] = "ERN";
    Currencies["GNF"] = "GNF";
    Currencies["LSL"] = "LSL";
    Currencies["LYD"] = "LYD";
    Currencies["MWK"] = "MWK";
    Currencies["MRO"] = "MRO";
    Currencies["SLL"] = "SLL";
    Currencies["SZL"] = "SZL";
    Currencies["TJS"] = "TJS";
    Currencies["TOP"] = "TOP";
    Currencies["XPF"] = "XPF";
    Currencies["XOF"] = "XOF";
    Currencies["XAF"] = "XAF";
    Currencies["WST"] = "WST";
    Currencies["VUV"] = "VUV";
    Currencies["UGX"] = "UGX";
    Currencies["TZS"] = "TZS";
    Currencies["STD"] = "STD";
    Currencies["RWF"] = "RWF";
    Currencies["PGK"] = "PGK";
    Currencies["MVR"] = "MVR";
    Currencies["MOP"] = "MOP";
    Currencies["MMK"] = "MMK";
    Currencies["MDL"] = "MDL";
    Currencies["HTG"] = "HTG";
    Currencies["GMD"] = "GMD";
    Currencies["GEL"] = "GEL";
    Currencies["ETB"] = "ETB";
    Currencies["BTN"] = "BTN";
    Currencies["BDT"] = "BDT";
    Currencies["AOA"] = "AOA";
    Currencies["AED"] = "AED";
    Currencies["MGA"] = "MGA";
    Currencies["GHS"] = "GHS";
    Currencies["TMT"] = "TMT";
    Currencies["DZD"] = "DZD";
    Currencies["MAD"] = "MAD";
    Currencies["KWD"] = "KWD";
    Currencies["TND"] = "TND";
    Currencies["AZN"] = "AZN";
    Currencies["BGL"] = "BGL";
    Currencies["BGN"] = "BGN";
    Currencies["UZS"] = "UZS";
    Currencies["KZT"] = "KZT";
    Currencies["KGS"] = "KGS";
    Currencies["RSD"] = "RSD";
    Currencies["MKD"] = "MKD";
    Currencies["TTD"] = "TTD";
    Currencies["PEN"] = "PEN";
    Currencies["SOS"] = "SOS";
    Currencies["IDR"] = "IDR";
    Currencies["DOP"] = "DOP";
    Currencies["ZAR"] = "ZAR";
    Currencies["GTQ"] = "GTQ";
    Currencies["BYN"] = "BYN";
    Currencies["BWP"] = "BWP";
    Currencies["MZN"] = "MZN";
    Currencies["ALL"] = "ALL";
    Currencies["RON"] = "RON";
    Currencies["HNL"] = "HNL";
    Currencies["KES"] = "KES";
    Currencies["ISK"] = "ISK";
    Currencies["HRK"] = "HRK";
    Currencies["BAM"] = "BAM";
    Currencies["JOD"] = "JOD";
    Currencies["JMD"] = "JMD";
    Currencies["PYG"] = "PYG";
    Currencies["AWG"] = "AWG";
    Currencies["ANG"] = "ANG";
    Currencies["NIO"] = "NIO";
    Currencies["BZD"] = "BZD";
    Currencies["VEF"] = "VEF";
    Currencies["PAB"] = "PAB";
    Currencies["YER"] = "YER";
    Currencies["SAR"] = "SAR";
    Currencies["QAR"] = "QAR";
    Currencies["OMR"] = "OMR";
    Currencies["SCR"] = "SCR";
    Currencies["PKR"] = "PKR";
    Currencies["NPR"] = "NPR";
    Currencies["MUR"] = "MUR";
    Currencies["LKR"] = "LKR";
    Currencies["UAH"] = "UAH";
    Currencies["MNT"] = "MNT";
    Currencies["LAK"] = "LAK";
    Currencies["VND"] = "VND";
    Currencies["KRW"] = "KRW";
    Currencies["NGN"] = "NGN";
    Currencies["CRC"] = "CRC";
    Currencies["KHR"] = "KHR";
    Currencies["AFN"] = "AFN";
    Currencies["CNY"] = "CNY";
    Currencies["FKP"] = "FKP";
    Currencies["SHP"] = "SHP";
    Currencies["GIP"] = "GIP";
    Currencies["LBP"] = "LBP";
    Currencies["EGP"] = "EGP";
    Currencies["UYU"] = "UYU";
    Currencies["BOB"] = "BOB";
    Currencies["BMD"] = "BMD";
    Currencies["SBD"] = "SBD";
    Currencies["XCD"] = "XCD";
    Currencies["LRD"] = "LRD";
    Currencies["KYD"] = "KYD";
    Currencies["GYD"] = "GYD";
    Currencies["FJD"] = "FJD";
    Currencies["COP"] = "COP";
    Currencies["CLP"] = "CLP";
    Currencies["BSD"] = "BSD";
    Currencies["BND"] = "BND";
    Currencies["BBD"] = "BBD";
    Currencies["ARS"] = "ARS";
    Currencies["NAD"] = "NAD";
    Currencies["SRD"] = "SRD";
    Currencies["BHD"] = "BHD";
    Currencies["AMD"] = "AMD";
    Currencies["TRY"] = "TRY";
    Currencies["INR"] = "INR";
    Currencies["IQD"] = "IQD";
    Currencies["ZMW"] = "ZMW";
})(Currencies || (Currencies = {}));
const CURRENCIES = {
    [Currencies.BIF]: { symbol: 'FBu' },
    [Currencies.CVE]: { symbol: '$' },
    [Currencies.KMF]: { symbol: 'CF' },
    [Currencies.CDF]: { symbol: 'FC' },
    [Currencies.DJF]: { symbol: 'Fdj' },
    [Currencies.ERN]: { symbol: 'ናቕፋ' },
    [Currencies.GNF]: { symbol: 'FG' },
    [Currencies.LSL]: { symbol: 'L' },
    [Currencies.LYD]: { symbol: 'ل.د' },
    [Currencies.MWK]: { symbol: 'MK' },
    [Currencies.MRO]: { symbol: 'UM' },
    [Currencies.SLL]: { symbol: 'LE' },
    [Currencies.SZL]: { symbol: 'L' },
    [Currencies.TJS]: { symbol: 'TJS' },
    [Currencies.TOP]: { symbol: 'T$' },
    [Currencies.XPF]: { symbol: 'F' },
    [Currencies.XOF]: { symbol: 'CFA' },
    [Currencies.XAF]: { symbol: 'FCFA' },
    [Currencies.WST]: { symbol: 'WS$' },
    [Currencies.VUV]: { symbol: 'VT' },
    [Currencies.UGX]: { symbol: 'USh' },
    [Currencies.TZS]: { symbol: 'TSh' },
    [Currencies.STD]: { symbol: 'Db' },
    [Currencies.RWF]: { symbol: 'R₣' },
    [Currencies.PGK]: { symbol: 'K' },
    [Currencies.MVR]: { symbol: 'Rf' },
    [Currencies.MOP]: { symbol: 'MOP$' },
    [Currencies.MMK]: { symbol: 'K' },
    [Currencies.MDL]: { symbol: 'L' },
    [Currencies.HTG]: { symbol: 'G' },
    [Currencies.GMD]: { symbol: 'D' },
    [Currencies.GEL]: { symbol: 'GEL' },
    [Currencies.ETB]: { symbol: 'Br' },
    [Currencies.BTN]: { symbol: 'Nu.' },
    [Currencies.BDT]: { symbol: '৳' },
    [Currencies.AOA]: { symbol: 'Kz' },
    [Currencies.AED]: { symbol: 'AED' },
    [Currencies.MGA]: { symbol: 'Ar' },
    [Currencies.GHS]: { symbol: 'GH₵' },
    [Currencies.TMT]: { symbol: 'T' },
    [Currencies.DZD]: { symbol: 'دج' },
    [Currencies.MAD]: { symbol: 'د.م.' },
    [Currencies.KWD]: { symbol: 'د.ك' },
    [Currencies.TND]: { symbol: 'د.ت' },
    [Currencies.AZN]: { symbol: 'ман' },
    [Currencies.BGL]: { symbol: 'лв', isDisabled: true },
    [Currencies.BGN]: { symbol: 'лв' },
    [Currencies.UZS]: { symbol: 'сум' },
    [Currencies.KZT]: { symbol: '₸' },
    [Currencies.KGS]: { symbol: 'сом' },
    [Currencies.RSD]: { symbol: 'РСД' },
    [Currencies.MKD]: { symbol: 'ден' },
    [Currencies.TTD]: { symbol: 'TT$' },
    [Currencies.PEN]: { symbol: 'S/.' },
    [Currencies.SOS]: { symbol: 'S' },
    [Currencies.IDR]: { symbol: 'Rp' },
    [Currencies.DOP]: { symbol: 'RD$' },
    [Currencies.ZAR]: { symbol: 'R' },
    [Currencies.GTQ]: { symbol: 'Q' },
    [Currencies.BYN]: { symbol: 'BYR' },
    [Currencies.BWP]: { symbol: 'P' },
    [Currencies.MZN]: { symbol: 'MT' },
    [Currencies.ALL]: { symbol: 'Lek' },
    [Currencies.RON]: { symbol: 'lei' },
    [Currencies.HNL]: { symbol: 'L' },
    [Currencies.KES]: { symbol: 'Ksh' },
    [Currencies.ISK]: { symbol: 'kr' },
    [Currencies.HRK]: { symbol: 'kn' },
    [Currencies.BAM]: { symbol: 'KM' },
    [Currencies.JOD]: { symbol: 'JD' },
    [Currencies.JMD]: { symbol: 'J$' },
    [Currencies.PYG]: { symbol: 'Gs' },
    [Currencies.AWG]: { symbol: 'ƒ' },
    [Currencies.ANG]: { symbol: 'ƒ' },
    [Currencies.NIO]: { symbol: 'C$' },
    [Currencies.BZD]: { symbol: 'BZ$' },
    [Currencies.VEF]: { symbol: 'Bs' },
    [Currencies.PAB]: { symbol: 'B/.' },
    [Currencies.YER]: { symbol: '﷼' },
    [Currencies.SAR]: { symbol: '﷼' },
    [Currencies.QAR]: { symbol: '﷼' },
    [Currencies.OMR]: { symbol: '﷼' },
    [Currencies.SCR]: { symbol: '₨' },
    [Currencies.PKR]: { symbol: '₨' },
    [Currencies.NPR]: { symbol: '₨' },
    [Currencies.MUR]: { symbol: '₨' },
    [Currencies.LKR]: { symbol: '₨' },
    [Currencies.UAH]: { symbol: '₴' },
    [Currencies.MNT]: { symbol: '₮' },
    [Currencies.LAK]: { symbol: '₭' },
    [Currencies.VND]: { symbol: '₫' },
    [Currencies.KRW]: { symbol: '₩' },
    [Currencies.NGN]: { symbol: '₦' },
    [Currencies.CRC]: { symbol: '₡' },
    [Currencies.KHR]: { symbol: '៛' },
    [Currencies.AFN]: { symbol: '؋' },
    [Currencies.CNY]: { symbol: '¥' },
    [Currencies.FKP]: { symbol: '£' },
    [Currencies.SHP]: { symbol: '£' },
    [Currencies.GIP]: { symbol: '£' },
    [Currencies.LBP]: { symbol: '.ل.ل' },
    [Currencies.EGP]: { symbol: '£' },
    [Currencies.UYU]: { symbol: '$U' },
    [Currencies.BOB]: { symbol: '$b' },
    [Currencies.BMD]: { symbol: 'BD$' },
    [Currencies.SBD]: { symbol: '$' },
    [Currencies.XCD]: { symbol: '$' },
    [Currencies.LRD]: { symbol: '$' },
    [Currencies.KYD]: { symbol: '$' },
    [Currencies.GYD]: { symbol: '$' },
    [Currencies.FJD]: { symbol: '$' },
    [Currencies.CLP]: { symbol: '$' },
    [Currencies.BSD]: { symbol: '$' },
    [Currencies.BND]: { symbol: '$' },
    [Currencies.BBD]: { symbol: '$' },
    [Currencies.ARS]: { symbol: '$' },
    [Currencies.NAD]: { symbol: '$' },
    [Currencies.SRD]: { symbol: '$' },
    [Currencies.BHD]: { symbol: '.د.ب' },
    [Currencies.AMD]: { symbol: 'AMD' },
    [Currencies.TRY]: { symbol: '₺' },
    [Currencies.INR]: { symbol: '₹' },
    [Currencies.IQD]: { symbol: 'ع.د' },
    [Currencies.ZMW]: { symbol: 'ZK' },
};
const COMMON_CURRENCY_SETTINGS = {
    offset: 2,
    subscription: { min: 0.01, max: 100000, default: 1 },
    rent: { min: 0.01, max: 100000, default: 1 },
    sale: { min: 0.01, max: 100000, default: 1 },
    pricing_plan: { min: 0.01, max: 100000, default: 1 },
};
export const BM_ADDITIONAL_CURRENCIES = Object.keys(CURRENCIES).reduce((acc, currency) => ({
    ...acc,
    [currency]: {
        ...COMMON_CURRENCY_SETTINGS,
        ...CURRENCIES[currency],
    },
}), {});
//# sourceMappingURL=bm-additional-currencies.js.map